import { useFormikContext } from "formik";
import React, { FC, useState } from 'react';
import { DEF_PG_SIZE_WIZARD } from '../../../../constants/maximum-page-size';
import { TranslationKeys } from '../../../../contexts/TranslationKeys';
import { useLocale } from '../../../../contexts/localeContext';
import { TableContextProvider } from '../../../../contexts/table/TableContextProvider';
import { TableColumn } from '../../../../models/table/TableColumn';
import DashboardTable from '../../dashboard-table';
import { getCategoryNameWithPagination } from "../../../../services/categoryService";

interface Props {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    setSideBarStepDescription: (discription: string) => void;
}

const TypeSelectionStep: FC<Props> = ({ onBack, onNext, setSideBarStepDescription, }) => {
    const [taskSelected, setTaskSelected] = useState(false);
    const { translate } = useLocale();
    const { setFieldValue, values, resetForm } = useFormikContext<any>();

    const TempColumns: TableColumn[] = [
        {
            heading: "Type",
            accessor: "label",
            isNumeric: false,
            id: 0,
            sortByName: "trnName",
            sortDirection: "asc",
            active: true,
            translationKey: translate.byKey(TranslationKeys.type),
            isDefault: true,
        }
    ];

    const onLocalNext = (event: any) => {
        if (taskSelected) {
            onNext({ ...event });
            setSideBarStepDescription(values.categoryType)
        }
    };

    const itemSelected = (selectedItem: any) => {
        resetForm();
        if (selectedItem) {
            setTaskSelected(true);
            setFieldValue("categoryType", selectedItem.label);
            setFieldValue("categoryTypeId", selectedItem.value);
            setFieldValue("categoryTypeSysname", selectedItem.elementSysname);
        }
    };
    
    return (
        <div className="pt-3 pr-3 pl-3 h-full">
            <div className="mb-3 text-portal-blue-primary-shade2 text-xl font-semibold">{translate.byKey(TranslationKeys.selectCategoryType)}</div>
            <TableContextProvider
                useTable
                dataMethod={getCategoryNameWithPagination}
                tableDescriptor={TempColumns}
                disableSearch={true}
                maxPageSize={DEF_PG_SIZE_WIZARD}>
                <DashboardTable onRowClicked={itemSelected}/>
            </TableContextProvider>

            <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
                <div className="flex flex-row justify-end mt-4 pl-3">
                    <button className={`py-1 px-5 secondary ${taskSelected ? "secondary-enabled" : "secondary-disabled cursor-not-allowed"}`}
                        type="button"
                        onClick={(e) => onLocalNext(e)}
                    >
                        {translate.byKey(TranslationKeys.next)}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TypeSelectionStep;